import { create } from 'zustand';
import {
    AnnouncementList,
    AnnouncementListPagination,
} from 'types/Announcement';
import { BASE_URL } from 'const/ConstBase';

interface State {
    announcementList: AnnouncementList[];
    pagination: AnnouncementListPagination;
}

const state: State = {
    announcementList: [],
    pagination: {} as AnnouncementListPagination,
};

interface Actions {
    fetchAnnouncementList: (
        page: number,
        category: string,
        searchText: string
    ) => void;
}

export const useAnnouncementListStore = create<State & Actions>((set) => ({
    ...state,
    fetchAnnouncementList: (
        page: number,
        category: string,
        searchText: string
    ) => {
        fetch(`${BASE_URL}notice/list/${page}/${category}/${searchText}`, {
            method: 'GET',
        })
            .then(async (res) => {
                const response = await res.json();

                set({
                    announcementList: response.data,
                    pagination: response.page,
                });
            })
            .catch(() => {
                console.log('fail');
            });
    },
}));
